const BASE_URL = process.env.REACT_APP_CDN_URL;
export default {
    getObjectURL: (Key: string): string => {
        return `${BASE_URL}${Key}`;
    }
};
